module.exports = __webpack_public_path__ + "img/health.98f5487.svg";